// extracted by mini-css-extract-plugin
export default {"transcriptMain":"transcription_transcriptMain__RXThg"};